
<app-topbar></app-topbar>

<div class="main-container upp-page">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<app-cookie-popup></app-cookie-popup>